var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valueDelta)?_c('span',{staticClass:"delta-arrow",class:_vm.getDeltaClass()},[_c('font-awesome-icon',{attrs:{"icon":_vm.getIcon()}}),_vm._v("\n  "+_vm._s(_vm._f("formatNullablePercent")(_vm.valueDelta,_vm.decimalPlaces))+"%\n")],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f289e3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/VectorWidgets/ux/Delta.vue
// module id = null
// module chunks = 